module.exports = __webpack_public_path__ + "static/media/form-header.a2d4f3d6.png";